var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.27028 8.97963L6.81622 4.3418H7.7649L9.31084 8.97963L13.9487 10.5256V11.4743L9.31084 13.0202L7.7649 17.658H6.81622L5.27028 13.0202L0.632446 11.4743V10.5256L5.27028 8.97963Z",
    fill: "url(#paint0_linear_56188_134)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0203 2.72963L14.8162 0.341797H15.7649L16.5608 2.72963L18.9487 3.52557V4.47425L16.5608 5.2702L15.7649 7.65802H14.8162L14.0203 5.2702L11.6324 4.47425V3.52557L14.0203 2.72963Z",
    fill: "url(#paint1_linear_56188_134)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_56188_134",
    x1: 0.632446,
    y1: 8.99991,
    x2: 18.9487,
    y2: 8.99991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DCC78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466554,
    stopColor: "#D3CE65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#A87BCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_56188_134",
    x1: 0.632446,
    y1: 8.99991,
    x2: 18.9487,
    y2: 8.99991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DCC78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466554,
    stopColor: "#D3CE65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#A87BCF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.99e5c2649cc5e8308077e50061e9bdb2.svg";
export { ForwardRef as ReactComponent };